import { PopoverTrigger as ChakraPopoverTrigger } from "@chakra-ui/react";

export const PopoverTrigger = ChakraPopoverTrigger;
